/**
 * KAN-897: вкладки "Мои лиды": "В работе" слева, "Отработано" справа, со счётчиками.
 * KAN-915: между ними "Следующая связь"; на узком экране подпись переносится.
 */
import { cn } from '@/lib/utils';
import { MOBILE_LEADS_TAB_LABELS, MOBILE_LEADS_TABS, type MobileLeadsTab } from '@/lib/mobileLeadsTabs';

interface MobileLeadsTabsProps {
  value: MobileLeadsTab;
  /** count ответа списка вкладки; undefined: ещё грузится. */
  counts: Record<MobileLeadsTab, number | undefined>;
  onChange: (tab: MobileLeadsTab) => void;
}

export function MobileLeadsTabs({ value, counts, onChange }: MobileLeadsTabsProps): JSX.Element {
  return (
    <div role="tablist" aria-label="Мои лиды" className="mb-3 grid grid-cols-3 gap-1 rounded-xl bg-gray-100 p-1">
      {MOBILE_LEADS_TABS.map((tab) => {
        const active = tab === value;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={`mobile-leads-tab-${tab}`}
            onClick={() => onChange(tab)}
            className={cn(
              'flex min-h-[44px] flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5 rounded-lg px-1.5 py-1 text-center text-[13px] font-medium leading-tight',
              active ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600'
            )}
          >
            {MOBILE_LEADS_TAB_LABELS[tab]}
            {counts[tab] !== undefined && (
              <span className="rounded-full bg-gray-200 px-2 text-xs text-gray-700">{counts[tab]}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
